import { useContext } from 'react';
import { TakeUndoableMutationContext } from "./TakeUndoableMutationContext.js";
export var useTakeUndoableMutation = function () {
    return useContext(TakeUndoableMutationContext);
};
//# sourceMappingURL=useTakeUndoableMutation.js.map